import React, { useState } from 'react';
import './TicTacToe.css';

function TicTacToe() {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);

  const handleClick = (index) => {
    if (board[index] || calculateWinner(board)) return;
    const newBoard = board.slice();
    newBoard[index] = isXNext ? 'X' : 'O';
    setBoard(newBoard);
    setIsXNext(!isXNext);
  };

  const calculateWinner = (board) => {
    const winningLines = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8], // Rows
      [0, 3, 6], [1, 4, 7], [2, 5, 8], // Columns
      [0, 4, 8], [2, 4, 6], // Diagonals
    ];

    for (const line of winningLines) {
      const [a, b, c] = line;
      if (board[a] && board[a] === board[b] && board[a] === board[c]) {
        return { winner: board[a], winningLine: line }; // Return winner and winning line
      }
    }
    return null;
  };

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
  };

  const result = calculateWinner(board);
  const winner = result ? result.winner : null;
  const winningLine = result ? result.winningLine : null;

  const status = winner
    ? `Winner: ${winner}`
    : board.every((cell) => cell)
    ? 'Draw!'
    : `Next Player: ${isXNext ? 'X' : 'O'}`;

  return (
    <div className='tic-tac-toe'>
      <h1>READY TO PLAY?</h1>
      <div className='status'>{status}</div>
      <div className='board'>
        {board.map((cell, index) => (
          <button
            key={index}
            className={`cell ${
              winningLine && winningLine.includes(index) ? 'winner-cell' : ''
            }`}
            onClick={() => handleClick(index)}
            disabled={cell || winner}
          >
            {cell}
          </button>
        ))}
      </div>
      <button className='reset-button' onClick={resetGame}>
        RESET
      </button>
    </div>
  );
}

export default TicTacToe;
